import { images, links, TID } from "@/data";
import { Link } from "react-router-dom";

const Purpose = () => {
  return (
    <section className="purpose section">
      <div className="container">
        <div className="purpose__grid">
          <div className="purpose__left">
            <h2 className="purpose__title">Purpose at<br />Our Core</h2>
            <p className="purpose__intro">
              We believe great travel uplifts not just travelers, but also local communities, cultures, and ecosystems. That’s why sustainability, responsibility, and respect are embedded into every journey we design.
            </p>

            <div className="purpose__item">
              <h3>Low-Impact Exploration</h3>
              <p>We prioritize ethical wildlife experiences, eco-conscious transportation, and boutique stays that support the environment, not exploit it.</p>
            </div>
            <div className="purpose__divider" />
            <div className="purpose__item">
              <h3>Local-first Partnerships</h3>
              <p>We work with local guides, artisans, and businesses to ensure tourism benefits the communities it touches, creating authentic, inclusive experiences.</p>
            </div>
            <div className="purpose__divider" />

            <Link to="/partner" className="btn btn--solid" data-testid={TID.purposeCta}>
              <span className="btn__dot" />Let’s Create Meaningful Journeys
            </Link>
          </div>
          <div className="purpose__right">
            <img src={images.elephants} alt="Elephants crossing a river in the wild" loading="lazy" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Purpose;
